export default {
    en: {
        dashboard: 'Dashboard',
        taskDashboard: 'Task dashboard',
        switchProject: 'Switch project',
        about: 'About',
        faqs: "FAQ's",
        newsAndViews: 'News and Views',
        contact: 'Contact',
        settings: 'Settings',
        wallpapers: 'Wallpapers',
        logout: 'Logout',
        allRightsReserved: 'All Rights Reserved',
        termsAndConditions: 'T&Cs',
        privacyPolicy: 'Privacy Policy',
        loadingTasks: 'Loading tasks',
        updateYourDetails: 'Update your details',
        switchProjectsWithCount: 'Switch Projects ({count})',
        switchProjectsModalTitle: 'Switch Projects',
        switchProjectsIntro: 'Select a project from the dropdown list below.<br/> Upon selection, you will be redirected to the corresponding task dashboard.',
        goToProject: 'Go to project',
        gettingProjects: 'Getting projects',
        selectProjectAria: 'Select a project to view',
        loggingOut: 'Logging out',
        loadingPage: 'Loading page',
        loadingFaqs: 'Loading FAQs',
        loadingNewsAndViews: 'Loading news and views',
        sendingMessage: 'Sending message',
        newsAndViewsIntro: 'All the latest news and updates from {communityName}.',
    },
    in: {
        dashboard: 'Dasbor',
        taskDashboard: 'Dasbor tugas',
        switchProject: 'Ganti proyek',
        about: 'Tentang',
        faqs: 'FAQ',
        newsAndViews: 'Berita dan Pandangan',
        contact: 'Kontak',
        settings: 'Pengaturan',
        wallpapers: 'Wallpaper',
        logout: 'Keluar',
        allRightsReserved: 'Hak Cipta Dilindungi',
        termsAndConditions: 'S&K',
        privacyPolicy: 'Kebijakan Privasi',
        loadingTasks: 'Memuat tugas',
        updateYourDetails: 'Perbarui detail Anda',
        switchProjectsWithCount: 'Ganti Proyek ({count})',
        switchProjectsModalTitle: 'Ganti Proyek',
        switchProjectsIntro: 'Pilih proyek dari daftar dropdown di bawah.<br/> Setelah dipilih, Anda akan diarahkan ke dasbor tugas yang sesuai.',
        goToProject: 'Buka proyek',
        gettingProjects: 'Mengambil proyek',
        selectProjectAria: 'Pilih proyek untuk dilihat',
        loggingOut: 'Sedang keluar',
        loadingPage: 'Memuat halaman',
        loadingFaqs: 'Memuat FAQ',
        loadingNewsAndViews: 'Memuat berita dan pandangan',
        sendingMessage: 'Mengirim pesan',
        newsAndViewsIntro: 'Semua berita dan pembaruan terbaru dari {communityName}.',
    },
    zh: {
        dashboard: '仪表盘',
        taskDashboard: '任务仪表盘',
        switchProject: '切换项目',
        about: '关于',
        faqs: '常见问题',
        newsAndViews: '新闻与观点',
        contact: '联系',
        settings: '设置',
        wallpapers: '壁纸',
        logout: '退出登录',
        allRightsReserved: '版权所有',
        termsAndConditions: '条款与条件',
        privacyPolicy: '隐私政策',
        loadingTasks: '正在加载任务',
        updateYourDetails: '更新您的详细信息',
        switchProjectsWithCount: '切换项目 ({count})',
        switchProjectsModalTitle: '切换项目',
        switchProjectsIntro: '请从下面的下拉列表中选择一个项目。<br/>选择后，您将被重定向到相应的任务仪表盘。',
        goToProject: '前往项目',
        gettingProjects: '正在获取项目',
        selectProjectAria: '选择要查看的项目',
        loggingOut: '正在退出',
        loadingPage: '正在加载页面',
        loadingFaqs: '正在加载常见问题',
        loadingNewsAndViews: '正在加载新闻与观点',
        sendingMessage: '正在发送消息',
        newsAndViewsIntro: '来自 {communityName} 的所有最新新闻和更新。',
    },
    nl: {
        dashboard: 'Dashboard',
        taskDashboard: 'Taakdashboard',
        switchProject: 'Project wisselen',
        about: 'Over',
        faqs: 'Veelgestelde vragen',
        newsAndViews: 'Nieuws en meningen',
        contact: 'Contact',
        settings: 'Instellingen',
        wallpapers: 'Achtergronden',
        logout: 'Uitloggen',
        allRightsReserved: 'Alle rechten voorbehouden',
        termsAndConditions: 'Algemene voorwaarden',
        privacyPolicy: 'Privacybeleid',
        loadingTasks: 'Taken laden',
        updateYourDetails: 'Werk uw gegevens bij',
        switchProjectsWithCount: 'Projecten wisselen ({count})',
        switchProjectsModalTitle: 'Projecten wisselen',
        switchProjectsIntro: 'Selecteer een project uit de onderstaande lijst.<br/> Na selectie wordt u doorgestuurd naar het bijbehorende taakdashboard.',
        goToProject: 'Ga naar project',
        gettingProjects: 'Projecten ophalen',
        selectProjectAria: 'Selecteer een project om te bekijken',
        loggingOut: 'Uitloggen',
        loadingPage: 'Pagina laden',
        loadingFaqs: 'Veelgestelde vragen laden',
        loadingNewsAndViews: 'Nieuws en meningen laden',
        sendingMessage: 'Bericht verzenden',
        newsAndViewsIntro: 'Al het laatste nieuws en updates van {communityName}.',
    },
    fi: {
        dashboard: 'Hallintapaneeli',
        taskDashboard: 'Tehtäväkoontinäyttö',
        switchProject: 'Vaihda projektia',
        about: 'Tietoa',
        faqs: 'UKK',
        newsAndViews: 'Uutiset ja näkemykset',
        contact: 'Yhteystiedot',
        settings: 'Asetukset',
        wallpapers: 'Taustakuvat',
        logout: 'Kirjaudu ulos',
        allRightsReserved: 'Kaikki oikeudet pidätetään',
        termsAndConditions: 'Ehdot',
        privacyPolicy: 'Tietosuojakäytäntö',
        loadingTasks: 'Ladataan tehtäviä',
        updateYourDetails: 'Päivitä tietosi',
        switchProjectsWithCount: 'Vaihda projekteja ({count})',
        switchProjectsModalTitle: 'Vaihda projekteja',
        switchProjectsIntro: 'Valitse projekti alla olevasta pudotusvalikosta.<br/> Valinnan jälkeen sinut ohjataan vastaavaan tehtäväkoontinäyttöön.',
        goToProject: 'Siirry projektiin',
        gettingProjects: 'Haetaan projekteja',
        selectProjectAria: 'Valitse näytettävä projekti',
        loggingOut: 'Kirjaudutaan ulos',
        loadingPage: 'Ladataan sivua',
        loadingFaqs: 'Ladataan UKK',
        loadingNewsAndViews: 'Ladataan uutisia ja näkemyksiä',
        sendingMessage: 'Lähetetään viestiä',
        newsAndViewsIntro: 'Kaikki uusimmat uutiset ja päivitykset kohteesta {communityName}.',
    },
    fr: {
        dashboard: 'Tableau de bord',
        taskDashboard: 'Tableau de bord des tâches',
        switchProject: 'Changer de projet',
        about: 'À propos',
        faqs: 'FAQ',
        newsAndViews: 'Actualités et points de vue',
        contact: 'Contact',
        settings: 'Paramètres',
        wallpapers: 'Fonds d\'écran',
        logout: 'Déconnexion',
        allRightsReserved: 'Tous droits réservés',
        termsAndConditions: 'CGU',
        privacyPolicy: 'Politique de confidentialité',
        loadingTasks: 'Chargement des tâches',
        updateYourDetails: 'Mettre à jour vos informations',
        switchProjectsWithCount: 'Changer de projet ({count})',
        switchProjectsModalTitle: 'Changer de projet',
        switchProjectsIntro: 'Sélectionnez un projet dans la liste ci-dessous.<br/> Après sélection, vous serez redirigé vers le tableau de bord des tâches correspondant.',
        goToProject: 'Aller au projet',
        gettingProjects: 'Récupération des projets',
        selectProjectAria: 'Sélectionnez un projet à afficher',
        loggingOut: 'Déconnexion en cours',
        loadingPage: 'Chargement de la page',
        loadingFaqs: 'Chargement des FAQ',
        loadingNewsAndViews: 'Chargement des actualités',
        sendingMessage: 'Envoi du message',
        newsAndViewsIntro: 'Toutes les dernières actualités et mises à jour de {communityName}.',
    },
    de: {
        dashboard: 'Dashboard',
        taskDashboard: 'Aufgaben-Dashboard',
        switchProject: 'Projekt wechseln',
        about: 'Über uns',
        faqs: 'FAQ',
        newsAndViews: 'Neuigkeiten und Ansichten',
        contact: 'Kontakt',
        settings: 'Einstellungen',
        wallpapers: 'Hintergrundbilder',
        logout: 'Abmelden',
        allRightsReserved: 'Alle Rechte vorbehalten',
        termsAndConditions: 'AGB',
        privacyPolicy: 'Datenschutzrichtlinie',
        loadingTasks: 'Aufgaben werden geladen',
        updateYourDetails: 'Details aktualisieren',
        switchProjectsWithCount: 'Projekte wechseln ({count})',
        switchProjectsModalTitle: 'Projekte wechseln',
        switchProjectsIntro: 'Wählen Sie ein Projekt aus der Dropdown-Liste unten.<br/> Nach der Auswahl werden Sie zum entsprechenden Aufgaben-Dashboard weitergeleitet.',
        goToProject: 'Zum Projekt',
        gettingProjects: 'Projekte werden geladen',
        selectProjectAria: 'Projekt zum Anzeigen auswählen',
        loggingOut: 'Abmeldung läuft',
        loadingPage: 'Seite wird geladen',
        loadingFaqs: 'FAQ werden geladen',
        loadingNewsAndViews: 'Neuigkeiten werden geladen',
        sendingMessage: 'Nachricht wird gesendet',
        newsAndViewsIntro: 'Alle neuesten Nachrichten und Updates von {communityName}.',
    },
    hi: {
        dashboard: 'डैशबोर्ड',
        taskDashboard: 'कार्य डैशबोर्ड',
        switchProject: 'प्रोजेक्ट बदलें',
        about: 'के बारे में',
        faqs: 'अक्सर पूछे जाने वाले प्रश्न',
        newsAndViews: 'समाचार और विचार',
        contact: 'संपर्क',
        settings: 'सेटिंग्स',
        wallpapers: 'वॉलपेपर',
        logout: 'लॉग आउट',
        allRightsReserved: 'सर्वाधिकार सुरक्षित',
        termsAndConditions: 'नियम और शर्तें',
        privacyPolicy: 'गोपनीयता नीति',
        loadingTasks: 'कार्य लोड हो रहे हैं',
        updateYourDetails: 'अपना विवरण अपडेट करें',
        switchProjectsWithCount: 'प्रोजेक्ट बदलें ({count})',
        switchProjectsModalTitle: 'प्रोजेक्ट बदलें',
        switchProjectsIntro: 'नीचे दी गई सूची से एक प्रोजेक्ट चुनें।<br/> चयन के बाद, आपको संबंधित कार्य डैशबोर्ड पर भेज दिया जाएगा।',
        goToProject: 'प्रोजेक्ट पर जाएं',
        gettingProjects: 'प्रोजेक्ट प्राप्त हो रहे हैं',
        selectProjectAria: 'देखने के लिए प्रोजेक्ट चुनें',
        loggingOut: 'लॉग आउट हो रहा है',
        loadingPage: 'पृष्ठ लोड हो रहा है',
        loadingFaqs: 'अक्सर पूछे जाने वाले प्रश्न लोड हो रहे हैं',
        loadingNewsAndViews: 'समाचार लोड हो रहे हैं',
        sendingMessage: 'संदेश भेजा जा रहा है',
        newsAndViewsIntro: '{communityName} से सभी नवीनतम समाचार और अपडेट।',
    },
    it: {
        dashboard: 'Dashboard',
        taskDashboard: 'Dashboard attività',
        switchProject: 'Cambia progetto',
        about: 'Informazioni',
        faqs: 'FAQ',
        newsAndViews: 'Notizie e opinioni',
        contact: 'Contatto',
        settings: 'Impostazioni',
        wallpapers: 'Sfondi',
        logout: 'Esci',
        allRightsReserved: 'Tutti i diritti riservati',
        termsAndConditions: 'Termini e condizioni',
        privacyPolicy: 'Informativa sulla privacy',
        loadingTasks: 'Caricamento attività',
        updateYourDetails: 'Aggiorna i tuoi dati',
        switchProjectsWithCount: 'Cambia progetto ({count})',
        switchProjectsModalTitle: 'Cambia progetto',
        switchProjectsIntro: 'Seleziona un progetto dal menu a tendina qui sotto.<br/> Dopo la selezione, verrai reindirizzato alla dashboard delle attività corrispondente.',
        goToProject: 'Vai al progetto',
        gettingProjects: 'Recupero progetti',
        selectProjectAria: 'Seleziona un progetto da visualizzare',
        loggingOut: 'Disconnessione in corso',
        loadingPage: 'Caricamento pagina',
        loadingFaqs: 'Caricamento FAQ',
        loadingNewsAndViews: 'Caricamento notizie',
        sendingMessage: 'Invio messaggio',
        newsAndViewsIntro: 'Tutte le ultime notizie e aggiornamenti da {communityName}.',
    },
    ja: {
        dashboard: 'ダッシュボード',
        taskDashboard: 'タスクダッシュボード',
        switchProject: 'プロジェクトを切り替え',
        about: '概要',
        faqs: 'よくある質問',
        newsAndViews: 'ニュースと意見',
        contact: 'お問い合わせ',
        settings: '設定',
        wallpapers: '壁紙',
        logout: 'ログアウト',
        allRightsReserved: '無断転載を禁じます',
        termsAndConditions: '利用規約',
        privacyPolicy: 'プライバシーポリシー',
        loadingTasks: 'タスクを読み込み中',
        updateYourDetails: '詳細を更新',
        switchProjectsWithCount: 'プロジェクトを切り替え ({count})',
        switchProjectsModalTitle: 'プロジェクトを切り替え',
        switchProjectsIntro: '下のドロップダウンからプロジェクトを選択してください。<br/> 選択後、対応するタスクダッシュボードにリダイレクトされます。',
        goToProject: 'プロジェクトへ',
        gettingProjects: 'プロジェクトを取得中',
        selectProjectAria: '表示するプロジェクトを選択',
        loggingOut: 'ログアウト中',
        loadingPage: 'ページを読み込み中',
        loadingFaqs: 'よくある質問を読み込み中',
        loadingNewsAndViews: 'ニュースを読み込み中',
        sendingMessage: 'メッセージを送信中',
        newsAndViewsIntro: '{communityName} の最新ニュースと更新情報。',
    },
    ko: {
        dashboard: '대시보드',
        taskDashboard: '작업 대시보드',
        switchProject: '프로젝트 전환',
        about: '소개',
        faqs: '자주 묻는 질문',
        newsAndViews: '뉴스 및 의견',
        contact: '문의',
        settings: '설정',
        wallpapers: '배경 화면',
        logout: '로그아웃',
        allRightsReserved: '모든 권리 보유',
        termsAndConditions: '이용 약관',
        privacyPolicy: '개인정보 처리방침',
        loadingTasks: '작업 로딩 중',
        updateYourDetails: '세부 정보 업데이트',
        switchProjectsWithCount: '프로젝트 전환 ({count})',
        switchProjectsModalTitle: '프로젝트 전환',
        switchProjectsIntro: '아래 드롭다운에서 프로젝트를 선택하세요.<br/> 선택하면 해당 작업 대시보드로 이동합니다.',
        goToProject: '프로젝트로 이동',
        gettingProjects: '프로젝트 가져오는 중',
        selectProjectAria: '볼 프로젝트 선택',
        loggingOut: '로그아웃 중',
        loadingPage: '페이지 로딩 중',
        loadingFaqs: '자주 묻는 질문 로딩 중',
        loadingNewsAndViews: '뉴스 로딩 중',
        sendingMessage: '메시지 전송 중',
        newsAndViewsIntro: '{communityName}의 최신 뉴스 및 업데이트.',
    },
    pl: {
        dashboard: 'Panel',
        taskDashboard: 'Panel zadań',
        switchProject: 'Zmień projekt',
        about: 'O nas',
        faqs: 'FAQ',
        newsAndViews: 'Aktualności i opinie',
        contact: 'Kontakt',
        settings: 'Ustawienia',
        wallpapers: 'Tapety',
        logout: 'Wyloguj',
        allRightsReserved: 'Wszelkie prawa zastrzeżone',
        termsAndConditions: 'Regulamin',
        privacyPolicy: 'Polityka prywatności',
        loadingTasks: 'Ładowanie zadań',
        updateYourDetails: 'Zaktualizuj swoje dane',
        switchProjectsWithCount: 'Zmień projekt ({count})',
        switchProjectsModalTitle: 'Zmień projekt',
        switchProjectsIntro: 'Wybierz projekt z listy poniżej.<br/> Po wyborze zostaniesz przekierowany do odpowiedniego panelu zadań.',
        goToProject: 'Przejdź do projektu',
        gettingProjects: 'Pobieranie projektów',
        selectProjectAria: 'Wybierz projekt do wyświetlenia',
        loggingOut: 'Wylogowywanie',
        loadingPage: 'Ładowanie strony',
        loadingFaqs: 'Ładowanie FAQ',
        loadingNewsAndViews: 'Ładowanie aktualności',
        sendingMessage: 'Wysyłanie wiadomości',
        newsAndViewsIntro: 'Wszystkie najnowsze wiadomości i aktualizacje od {communityName}.',
    },
    pt: {
        dashboard: 'Painel',
        taskDashboard: 'Painel de tarefas',
        switchProject: 'Mudar de projeto',
        about: 'Sobre',
        faqs: 'Perguntas frequentes',
        newsAndViews: 'Notícias e opiniões',
        contact: 'Contacto',
        settings: 'Definições',
        wallpapers: 'Papéis de parede',
        logout: 'Terminar sessão',
        allRightsReserved: 'Todos os direitos reservados',
        termsAndConditions: 'Termos e condições',
        privacyPolicy: 'Política de privacidade',
        loadingTasks: 'A carregar tarefas',
        updateYourDetails: 'Atualizar os seus dados',
        switchProjectsWithCount: 'Mudar de projeto ({count})',
        switchProjectsModalTitle: 'Mudar de projeto',
        switchProjectsIntro: 'Selecione um projeto na lista abaixo.<br/> Após a seleção, será redirecionado para o painel de tarefas correspondente.',
        goToProject: 'Ir para o projeto',
        gettingProjects: 'A obter projetos',
        selectProjectAria: 'Selecione um projeto para ver',
        loggingOut: 'A terminar sessão',
        loadingPage: 'A carregar página',
        loadingFaqs: 'A carregar perguntas frequentes',
        loadingNewsAndViews: 'A carregar notícias',
        sendingMessage: 'A enviar mensagem',
        newsAndViewsIntro: 'Todas as últimas notícias e atualizações de {communityName}.',
    },
    es: {
        dashboard: 'Panel',
        taskDashboard: 'Panel de tareas',
        switchProject: 'Cambiar proyecto',
        about: 'Acerca de',
        faqs: 'Preguntas frecuentes',
        newsAndViews: 'Noticias y opiniones',
        contact: 'Contacto',
        settings: 'Ajustes',
        wallpapers: 'Fondos de pantalla',
        logout: 'Cerrar sesión',
        allRightsReserved: 'Todos los derechos reservados',
        termsAndConditions: 'Términos y condiciones',
        privacyPolicy: 'Política de privacidad',
        loadingTasks: 'Cargando tareas',
        updateYourDetails: 'Actualizar tus datos',
        switchProjectsWithCount: 'Cambiar proyecto ({count})',
        switchProjectsModalTitle: 'Cambiar proyecto',
        switchProjectsIntro: 'Selecciona un proyecto de la lista desplegable a continuación.<br/> Tras la selección, serás redirigido al panel de tareas correspondiente.',
        goToProject: 'Ir al proyecto',
        gettingProjects: 'Obteniendo proyectos',
        selectProjectAria: 'Selecciona un proyecto para ver',
        loggingOut: 'Cerrando sesión',
        loadingPage: 'Cargando página',
        loadingFaqs: 'Cargando preguntas frecuentes',
        loadingNewsAndViews: 'Cargando noticias',
        sendingMessage: 'Enviando mensaje',
        newsAndViewsIntro: 'Todas las últimas noticias y actualizaciones de {communityName}.',
    },
    tr: {
        dashboard: 'Kontrol Paneli',
        taskDashboard: 'Görev paneli',
        switchProject: 'Proje değiştir',
        about: 'Hakkında',
        faqs: 'SSS',
        newsAndViews: 'Haberler ve görüşler',
        contact: 'İletişim',
        settings: 'Ayarlar',
        wallpapers: 'Duvar kağıtları',
        logout: 'Çıkış yap',
        allRightsReserved: 'Tüm hakları saklıdır',
        termsAndConditions: 'Şartlar ve koşullar',
        privacyPolicy: 'Gizlilik politikası',
        loadingTasks: 'Görevler yükleniyor',
        updateYourDetails: 'Bilgilerinizi güncelleyin',
        switchProjectsWithCount: 'Proje değiştir ({count})',
        switchProjectsModalTitle: 'Proje değiştir',
        switchProjectsIntro: 'Aşağıdaki listeden bir proje seçin.<br/> Seçimden sonra ilgili görev paneline yönlendirileceksiniz.',
        goToProject: 'Projeye git',
        gettingProjects: 'Projeler alınıyor',
        selectProjectAria: 'Görüntülenecek projeyi seçin',
        loggingOut: 'Çıkış yapılıyor',
        loadingPage: 'Sayfa yükleniyor',
        loadingFaqs: 'SSS yükleniyor',
        loadingNewsAndViews: 'Haberler yükleniyor',
        sendingMessage: 'Mesaj gönderiliyor',
        newsAndViewsIntro: '{communityName} kaynaklı tüm son haberler ve güncellemeler.',
    },
    vi: {
        dashboard: 'Bảng điều khiển',
        taskDashboard: 'Bảng điều khiển nhiệm vụ',
        switchProject: 'Chuyển dự án',
        about: 'Giới thiệu',
        faqs: 'Câu hỏi thường gặp',
        newsAndViews: 'Tin tức và quan điểm',
        contact: 'Liên hệ',
        settings: 'Cài đặt',
        wallpapers: 'Hình nền',
        logout: 'Đăng xuất',
        allRightsReserved: 'Bảo lưu mọi quyền',
        termsAndConditions: 'Điều khoản',
        privacyPolicy: 'Chính sách quyền riêng tư',
        loadingTasks: 'Đang tải nhiệm vụ',
        updateYourDetails: 'Cập nhật thông tin của bạn',
        switchProjectsWithCount: 'Chuyển dự án ({count})',
        switchProjectsModalTitle: 'Chuyển dự án',
        switchProjectsIntro: 'Chọn một dự án từ danh sách bên dưới.<br/> Sau khi chọn, bạn sẽ được chuyển đến bảng điều khiển nhiệm vụ tương ứng.',
        goToProject: 'Đi tới dự án',
        gettingProjects: 'Đang lấy dự án',
        selectProjectAria: 'Chọn dự án để xem',
        loggingOut: 'Đang đăng xuất',
        loadingPage: 'Đang tải trang',
        loadingFaqs: 'Đang tải câu hỏi thường gặp',
        loadingNewsAndViews: 'Đang tải tin tức',
        sendingMessage: 'Đang gửi tin nhắn',
        newsAndViewsIntro: 'Tất cả tin tức và cập nhật mới nhất từ {communityName}.',
    },
    ar: {
        dashboard: 'لوحة التحكم',
        taskDashboard: 'لوحة مهام المشارك',
        switchProject: 'تبديل المشروع',
        about: 'حول',
        faqs: 'الأسئلة الشائعة',
        newsAndViews: 'الأخبار والآراء',
        contact: 'اتصل بنا',
        settings: 'الإعدادات',
        wallpapers: 'خلفيات',
        logout: 'تسجيل الخروج',
        allRightsReserved: 'جميع الحقوق محفوظة',
        termsAndConditions: 'الشروط والأحكام',
        privacyPolicy: 'سياسة الخصوصية',
        loadingTasks: 'جارٍ تحميل المهام',
        updateYourDetails: 'تحديث بياناتك',
        switchProjectsWithCount: 'تبديل المشاريع ({count})',
        switchProjectsModalTitle: 'تبديل المشاريع',
        switchProjectsIntro: 'اختر مشروعًا من القائمة أدناه.<br/> بعد الاختيار، سيتم توجيهك إلى لوحة مهام المشروع المقابل.',
        goToProject: 'الانتقال إلى المشروع',
        gettingProjects: 'جارٍ جلب المشاريع',
        selectProjectAria: 'اختر مشروعًا للعرض',
        loggingOut: 'جارٍ تسجيل الخروج',
        loadingPage: 'جارٍ تحميل الصفحة',
        loadingFaqs: 'جارٍ تحميل الأسئلة الشائعة',
        loadingNewsAndViews: 'جارٍ تحميل الأخبار',
        sendingMessage: 'جارٍ إرسال الرسالة',
        newsAndViewsIntro: 'جميع آخر الأخبار والتحديثات من {communityName}.',
    },
};
